module.exports = __webpack_public_path__ + "img/cidi.c2bc4a10.png";